import React, { useRef, useEffect } from "react";
import videoFile from "../../components/money.mp4";
import audioFile from "../../components/delete.m4a";

function DeleteBankruptcy() {
  const videoRef = useRef(null);
  const audioRef = useRef(null);

  const handlePlay = () => {
    if (audioRef.current) {
      audioRef.current.play();
    }
  };

  useEffect(() => {
      const playMedia = async () => {
        if (videoRef.current && audioRef.current) {
          try {
            await videoRef.current.play();
            await audioRef.current.play();
          } catch (error) {
            console.log("Autoplay blocked by browser, user interaction needed.");
          }
        }
      };
      playMedia();
    }, []);

  return (
    <div className="container">
      <div className="banner" onClick={handlePlay}>
        <video
          ref={videoRef}
          src={videoFile}
          autoPlay
          loop
          muted
          playsInline
          className="video"
        />
      </div>

      <audio ref={audioRef} src={audioFile} />

      <div className="container_body">
        <div className="course">
          <h1>How to Delete Bankruptcy</h1>
          <p>
            Overcoming Bankruptcy: Rebuild and Rise Again! 📈💪 In this powerful
            session with Joshua Rico, we’re tackling the steps to bounce back
            from bankruptcy. Learn the strategies, rights, and tools you need to
            rebuild your credit and reclaim control over your financial future.
            This is your fresh start—let’s make it count! 🔥💼
            #BankruptcyRecovery #CreditRepair
          </p>
          <p>
            ver the shoulder step by step how to remove any negative items
            without sending letters and saying social media :{" "}
            <a href="https://750blueprint.com/">https://750blueprint.com/</a>
          </p>
          
        </div>
      </div>
    </div>
  );
}

export default DeleteBankruptcy;
